import { useLanguage } from '@/context/LanguageContext';
import { cn } from '@/lib/utils';

export const LanguageSwitcher = ({ className, variant = 'default' }) => {
    const { language, toggleLanguage } = useLanguage();

    const isLight = variant === 'light';

    return (
        <button
            onClick={toggleLanguage}
            className={cn(
                "flex items-center gap-1 px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200",
                isLight 
                    ? "bg-primary-foreground/10 hover:bg-primary-foreground/20 text-primary-foreground border border-primary-foreground/20"
                    : "bg-secondary hover:bg-secondary/80 text-foreground border border-border",
                className
            )}
            aria-label={`Switch to ${language === 'tr' ? 'English' : 'Turkish'}`}
        >
            <span className={cn(
                "transition-colors",
                language === 'tr' ? (isLight ? "text-accent" : "text-accent") : (isLight ? "text-primary-foreground/60" : "text-muted-foreground")
            )}>
                TR
            </span>
            <span className={cn(
                "text-xs",
                isLight ? "text-primary-foreground/40" : "text-muted-foreground"
            )}>
                |
            </span>
            <span className={cn(
                "transition-colors",
                language === 'en' ? (isLight ? "text-accent" : "text-accent") : (isLight ? "text-primary-foreground/60" : "text-muted-foreground")
            )}>
                EN
            </span>
        </button>
    );
};

export default LanguageSwitcher;
